import React, { FormEvent, Fragment, useContext, useEffect, useState } from "react";
import { Grid, Segment, Dropdown, Search, Button, Image, Input, Table, Confirm } from "semantic-ui-react";
import CertificateList from "./CertificateList";
import { observer } from "mobx-react-lite";
import CertificateStore from "../../../app/stores/certificateStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";

const CertificateDashboard: React.FC = () => {
  const certificateStore = useContext(CertificateStore);
  const { searchCertificate, certificatesSearch, deleteCertificate, submitting, target } = certificateStore;

  useEffect(() => {
    certificateStore.loadCertificates();
  }, [certificateStore]);

  const [term, setTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [certificateId, setCertificateId] = useState("");

  if (certificateStore.loadingInitial)
    return <LoadingComponent content="Loading Certificates" />;
  
  const handleSearch=(event: FormEvent<HTMLInputElement>) => {
      const {value} = event.currentTarget;
      setTerm(value);
      searchCertificate(event.currentTarget.value);
  }

  return (
    <Segment>
      <Grid>
        <Grid.Column width={11}>
           <Input  type="text" icon="search" placeholder="Search certificate" onChange={handleSearch} value={term}/>
        </Grid.Column>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={`/hrmanagement/certificate-create`}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      {(certificatesSearch.length !== 0) ? (
        <Table celled>
     <Table.Header>
       <Table.Row>
         <Table.HeaderCell>Name</Table.HeaderCell>
         <Table.HeaderCell>Category</Table.HeaderCell>
         <Table.HeaderCell>Level</Table.HeaderCell>
         <Table.HeaderCell>Description</Table.HeaderCell>
         <Table.HeaderCell width={1}>Action</Table.HeaderCell>
       </Table.Row>
     </Table.Header>

     <Table.Body>
     {certificatesSearch.map(certificate => (
      <Table.Row key={certificate.id}>
        <Table.Cell>
          <strong>{certificate.name}</strong>
        </Table.Cell>
        <Table.Cell>{certificate.category}</Table.Cell>
        <Table.Cell>{certificate.level}</Table.Cell>
        <Table.Cell>{certificate.description}</Table.Cell>
        <Table.Cell>
        <Button.Group size='mini'>
                <Button
                  as={Link}
                  to={`/hrmanagement/certificate/${certificate.id}`}
                  size='mini'
                  icon="zoom in"
                    color="blue"
                    title="View"
                />
                <Button
                  name={certificate.id}
                  size='mini'
                  loading={target === certificate.id && submitting}
                  onClick={() => {
                    setOpen(true);
                    setCertificateId(certificate.id);
                  }}
                  icon="delete"
                  color="red"
                  title="Delete"
                />
                <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteCertificate(certificateId);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
          </Button.Group>
        </Table.Cell>
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
      ) : (term) && <h4>No certificates found</h4>

      }
      <CertificateList />
    </Segment>
  );
};

export default observer(CertificateDashboard);
